module.exports = __webpack_public_path__ + "6570bcbebfa3bedf4054d824e80a657a.svg";